import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import { getRights } from "../../redux/actions/userRights.action";
import { useSelector, useDispatch } from 'react-redux';
import { ReadCookie, } from '../../utils/readCookie';
import Tables from "../../components/Table/Tables"
import { logColumns, returnReasonColumn } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import notification from '../../utils/notification'
import { getReturnResaon, addReturnReason, updateReturnReason, deleteReturnReason } from '../../redux/actions/returnreason.action';
import { TabTitle } from '../../utils/GeneralFunction';


const { TabPane } = Tabs;


const ReturnReason = ({ token }) => {
    TabTitle("Return Reason")
    const { userRights, log, returnreason } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [description, setDescription] = useState('');
    const [form] = Form.useForm();
    const descriptionInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [returnObj, setReturnObj] = useState(null);
    const [check, setCheck] = useState(true);
    const dispatch = useDispatch();
    const id = ReadCookie('menuId');


    useEffect(() => {
        dispatch(getReturnResaon(token))
    }, [dispatch, token])

    const handleDelete = () => {
        if (returnObj) {

            dispatch(deleteReturnReason(token, returnObj.return_reason_id)).then((res) => {
                if (res.type === "DELETE_RETURN_REASON_SUCCESS") {
                    notification("success", "Reason Deleted", "Reason deleted successfully!");
                }
                if (res.type === "DELETE_RETURN_REASON_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    desc: ""
                })
                setDescription("")
                setReturnObj(null)
                setFormState('view')
                dispatch(getReturnResaon(token, id))

            })
        }
        setFormState("view")
    }

    useEffect(() => {

        if (returnObj) {
            setFormState('view')
            form.setFieldsValue({
                id: returnObj.return_reason_id,
                desc: returnObj.description,
                active: returnObj.is_active,
            });
            setDescription(returnObj.description)
            setCheck(returnObj.is_active)
        }

    }, [returnObj]);

    useEffect(() => {
        if (description === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [description])




    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])
    useEffect(() => {
        dispatch(getLog(token, { admin_return_reason: "admin_return_reason" }))
    }, [dispatch, token])




    const formSave = async () => {

        await form.validateFields().then((values) => {
            if (formState === "add") {
                dispatch(addReturnReason(token, { description, is_active: check }, id)).then((res) => {

                    if (res.type === "ADD_RETURN_REASON_ERROR") {
                        notification("error", "Not Created", res?.payload?.data?.data)
                    }
                    if (res.type === "ADD_RETURN_REASON_SUCCESS") {
                        notification("success", "Reason Created", "Reason created successfully!");
                        form.setFieldsValue({
                            desc: ""
                        })
                        setFormState("view")
                        setDescription("")
                        setReturnObj(null)
                    }
                    dispatch(getReturnResaon(token, id))

                })

            }
            if (formState === "edit") {
                dispatch(updateReturnReason(token, { description, is_active: check }, returnObj.return_reason_id)).then((res) => {

                    if (res.type === "UPDATE_RETURN_REASON_ERROR") {
                        notification("error", "Update", "Something went wrong")
                    }
                    if (res.type === "UPDATE_RETURN_REASON_SUCCESS") {
                        notification("success", "Reason Updated", "Record updated successfully")
                    }
                    dispatch(getReturnResaon(token, id))
                })
            }

        }).catch((err) => {

        })




    }



    useEffect(() => {
        if (formState === "add") {
            descriptionInput.current.focus()
            form.setFieldsValue({
                cid: null,
                desc: null,


            })
            setCheck(true)
            setDescription("")
            setReturnObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
        setReturnObj(null)
        setCheck(true)
        form.setFieldsValue({
            cid: null,
            desc: "",
        })
        setDescription(null)

    }


    return (
        <div className='styleContainer'>
            <div className='styleBody h-100' >
                <PageHeader title={"Return Reason"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} disable={disable} reset={filterReset} save={formSave} onDelete={handleDelete} /></div>
                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="return" formState={formState} returnObj={setReturnObj} scrollX={"20rem"} source={returnreason?.payload?.data} col={returnReasonColumn} paginate scroll={500} perPage={25} load={returnreason.loading} rowKey="return_reason_id" />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                            // labelCol={{ span: 8 }}

                                            >
                                                <div className='customRow styleFormUpper ' >
                                                    {returnObj !== null && !(formState === "add") &&
                                                        <div className='customCols slc'>
                                                            <Form.Item
                                                                label="ID"
                                                                name="id"
                                                                initialValue={form.getFieldValue().id}
                                                                labelCol={{ span: 10 }}
                                                                wrapperCol={{ span: 14 }}

                                                            >
                                                                <Input size='small' className='styleInput id-field-style' readOnly />

                                                            </Form.Item>
                                                        </div>


                                                    }


                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Description"
                                                            name="desc"
                                                            initialValue={form.getFieldValue().city}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >

                                                            <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={descriptionInput} onChange={(e) => setDescription(e.target.value)} className='styleInput' />
                                                        </Form.Item>
                                                    </div>
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Active"
                                                            name="active"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className='modalStyle' >
                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered   >
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={800} perPage={10} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}


export default ReturnReason